<div class="plan-span">
  <div [ngClass]="badgeClass">
    <span>{{ plan }}</span>
  </div>
</div>
